export const timeAfter = {
  getMessage(field, [otherField]) {
    return `The ${field} needs to be after the ${otherField}.`;
  },
  validate(aTimeValue, [bTimeValue]) {
    if (!aTimeValue || !bTimeValue) {
      return true;
    }

    return Date.parse('01/01/2011 ' + aTimeValue) > Date.parse('01/01/2011 ' + bTimeValue);
  }
};

export const timeBefore = {
  getMessage(field, [otherField]) {
    return `The ${field} needs to be before the ${otherField}.`;
  },
  validate(aTimeValue, [bTimeValue]) {
    if (!aTimeValue || !bTimeValue) {
      return true;
    }

    return Date.parse('01/01/2011 ' + aTimeValue) < Date.parse('01/01/2011 ' + bTimeValue);
  }
};